/* Hard gate enforcement + prefill for all assessments */

const FORTIFY_GATE_KEY = 'fortify_gate_v1';

function getGate(){
  try { return JSON.parse(sessionStorage.getItem(FORTIFY_GATE_KEY) || 'null'); }
  catch { return null; }
}

function requireGate(){
  const gate = getGate();
  if(!gate || !gate.email || !gate.name){
    // Redirect to Shopify gate page
    window.location.href = '/pages/assessments';
    return null;
  }
  return gate;
}

function prefillCommonFields(gate){
  // If pages have name/email/phone inputs, fill them.
  const nameEl = document.getElementById('name');
  const emailEl = document.getElementById('email');
  const phoneEl = document.getElementById('phone');

  if(nameEl && !nameEl.value) nameEl.value = gate.name || '';
  if(emailEl && !emailEl.value) emailEl.value = gate.email || '';
  if(phoneEl && !phoneEl.value) phoneEl.value = gate.phone || '';
}

window.FortifyGate = { requireGate, prefillCommonFields, getGate };